module.exports = __webpack_public_path__ + "static/img/MIR SKIRT+.7fa270b4.svg";